import * as React from 'react';
import MuiFormHelperText, {
  FormHelperTextProps,
} from '@mui/material/FormHelperText';

interface IEDFormHelperTextProps extends FormHelperTextProps {
  warning?: boolean;
  lineMarker?: boolean;
}
const EDFormHelperText = (props: IEDFormHelperTextProps) => {
  const { warning, lineMarker, ...helperProps } = props;
  const textRef = React.useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = React.useState(false);

  React.useEffect(() => {
    if (textRef.current) {
      const lineHeight = 11 * 1.1;
      const maxHeight = lineHeight * 1 + 1;
      const actualHeight = textRef.current.scrollHeight;

      setIsOverflowing(actualHeight > maxHeight);
    }
  }, [props.children]);

  return (
    <>
      {/* This is an invisible element with zero height that never affects layout */}
      <div
        style={{
          height: 0,
          overflow: 'visible',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          width: '100%',
        }}
      >
        <MuiFormHelperText
          ref={textRef}
          {...helperProps}
          sx={[
            {
              marginTop: '1px',
              lineHeight: '1.1',
              fontSize: '11px',
              position: 'absolute',
              maxWidth: '100%',
              maxHeight: isOverflowing ? 'none' : '22px',
              overflow: isOverflowing ? 'visible' : 'hidden',
            },
            Boolean(warning && !helperProps.error) && {
              color: theme => theme.palette.warning.main,
            },
            Boolean(lineMarker) && {
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              bottom: 0,
              left: '4px',
              right: '4px',
              marginLeft: 0,
              marginRight: 0,
              fontSize: '11px',
              cursor: 'auto',
              paddingLeft: '3px',
              whiteSpace: 'nowrap',
            },
            !lineMarker && {
              whiteSpace: 'normal',
              marginLeft: 1,
              marginRight: 0,
            },
          ]}
        />
      </div>

      {/* Only render this spacer if text is overflowing beyond 1 line */}
      {isOverflowing && (
        <div
          style={{
            height: textRef.current ? textRef.current.scrollHeight : 0,
            marginBottom: '1px',
          }}
        />
      )}
    </>
  );
};
export default EDFormHelperText;
